module.exports = __webpack_public_path__ + "static/back-9ed3b63a16fe3d56d95438b675f6b486.gif";